import { render, staticRenderFns } from "./verificationList.vue?vue&type=template&id=5671a826&"
import script from "./verificationList.vue?vue&type=script&lang=js&"
export * from "./verificationList.vue?vue&type=script&lang=js&"
import style0 from "./verificationList.vue?vue&type=style&index=0&id=5671a826&prod&lang=less&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports